module.exports = __webpack_public_path__ + "media/sales_marketing_strategies/graph_1_2-446e212f.svg";